import { Form, Header } from '@mairistem/composants';
import { EtiquettesInput, FilterScope } from '@mairistem/finances-utils';
import { Liste, ListeQueryContext } from '@mairistem/liste';
import React from 'react';
import { useHistory } from 'react-router-dom';
import ProjetListeTable from '@/src/components/ProjetListe/ProjetListeTable';
import type { Etiquette } from '@/src/interfaces/etiquette';
import type { Projet } from '@/src/interfaces/projet';

interface ProjetListeProps {
	projets: Array<Projet>;
	count: number;
	perPage: number;
	loading: boolean;
	onLoad: any;
	onSearch: any;
	onSort: any;
	onSelected: any;
	onExplored: any;
	onExpanded: any;
	state: any;
	mode: any;
}

const ProjetListe = (props: ProjetListeProps) => {
	const {
		projets,
		count,
		perPage,
		loading,
		onLoad,
		onSort,
		onSelected,
		mode,
		...handlers
	} = props;

	const [selectedEtiquettes, setSelectedEtiquettes] = React.useState<
		Etiquette[]
	>([]);
	const [selectedStades, setSelectedStades] = React.useState<number[]>([
		0, 1, 2, 3,
	]);
	const context = React.useContext(ListeQueryContext);

	const handleEtiquetteChange = ({ etiquettes }) => {
		setSelectedEtiquettes(etiquettes);
		context.filterQuery({
			...(etiquettes.length > 0 && {
				'etiquettesId[]': etiquettes.map((etiquette) => etiquette.identifiant),
			}),
		});
	};

	const handleStadeChange = (_e, { value }) => {
		let newStades = [];
		if (selectedStades.includes(value)) {
			newStades = selectedStades.filter(
				(selectedStade) => selectedStade !== value,
			);
		} else {
			newStades = [...selectedStades, value];
		}
		setSelectedStades(newStades);
		context.filterQuery({ status: FilterScope.filterIn(newStades) });
	};

	const history = useHistory();
	const handleClick = () => {
		history.push('/projets');
	};

	return (
		<Liste
			title="Projets"
			mode={mode}
			searchable
			search={{
				placeholder: "Rechercher sur l'intitulé et la référence interne",
			}}
			// @ts-expect-error
			persistState={false}
			onExpand={handleClick}
			{...handlers}
		>
			<Liste.Header>
				{mode !== 'explorer' ? (
					<Header size="small">
						{count} {count > 1 ? 'projets' : 'projet'}
					</Header>
				) : (
					<Form>
						<Form.Group>
							<Form.Field
								control={EtiquettesInput}
								// @ts-expect-error allowAdditions
								baseUrl="/api/finances/subventionsPercues/etiquettes"
								allowAdditions={false}
								identifiantEntite={sessionStorage.getItem('identifiantEntite')}
								onChange={handleEtiquetteChange}
								selectedEtiquettes={selectedEtiquettes}
								dropdownProps={{ className: 'etiquettes' }}
							/>
							<div className="filterCheckboxed">
								<Form.Checkbox
									label="Conception"
									value={1}
									checked={selectedStades.includes(1)}
									onChange={handleStadeChange}
								/>
								<Form.Checkbox
									label="Planification"
									value={2}
									checked={selectedStades.includes(2)}
									onChange={handleStadeChange}
								/>
								<Form.Checkbox
									label="Exécution"
									value={3}
									checked={selectedStades.includes(3)}
									onChange={handleStadeChange}
								/>
								<Form.Checkbox
									label="Soldé"
									value={4}
									checked={selectedStades.includes(4)}
									onChange={handleStadeChange}
								/>
								<Form.Checkbox
									label="Aucun"
									value={0}
									checked={selectedStades.includes(0)}
									onChange={handleStadeChange}
								/>
							</div>
						</Form.Group>
					</Form>
				)}
			</Liste.Header>
			<Liste.Content>
				<ProjetListeTable
					items={projets}
					loading={loading}
					count={count}
					perPage={perPage}
					onLoad={onLoad}
					onSort={onSort}
					onSelect={onSelected}
					isExplorer={mode === 'explorer'}
				/>
			</Liste.Content>
		</Liste>
	);
};

export default ProjetListe;
